export class List {
    items = [];
}